import request from '@/utils/request'
const url = 'index.php/trainApp/api/trainApp/'

//练习列表
export function GetUserGradeByUser(query) {
    return request({
        url: url +'usersign/GetUserGradeByUser',
        method: 'get',
        params: query
    })
}


export function GetExamInfoById(query) {
    return request({
        url: url +'InstExam/GetExamInfoById',
        method: 'get',
        params: query
    })
}

export function GetQuestionItemByData(data) {
    return request({
        url: url +'InstExam/GetQuestionItemByData',
        method: 'post',
        data
    })
}

export function PostAddByData(data) {
    return request({
        url: url +'InstExamRecord/PostAddByData',
        method: 'post',
        data
    })
}

//题目报错
export function PostQuestionErrorData(data) {
    return request({
        url: url +'InstExam/PostQuestionErrorData',
        method: 'post',
        data
    })
}
export function GetUserRecordItemByData(query) {
    return request({
        url: url +'InstExamRecord/GetUserRecordItemByData',
        method: 'get',
        params: query
    })
}

export function GetQuestionItemById(query) {
    return request({
        url: url +'InstExamRecord/GetQuestionItemByData',
        method: 'get',
        params: query
    })
}


export function PostUserFiledByData(data) {
    return request({
        url: url +'user/PostUserFiledByData',
        method: 'post',
        data
    })
}


export function GetUserAutonymByUserId(user_id) {
    return request({
        url: url+'/user/GetUserAutonymByUserId',
        method: 'get',
        params: { user_id }
    })
}
